import $ from 'jquery';
import btmq from './Plugins/BootstrapMediaQuery';
import ifExists from './Plugins/ifExists';
import './src/map.js';

$(function () {

	// Document ready

    $.ifExists('#scrollToTop', function(scrollToTop){

        // Check to see if the window is top if not then display
        $(window).scroll(function(){
            if ($(this).scrollTop() > 200) {
                scrollToTop.css({bottom:"20px"});
            } else {
                scrollToTop.css({bottom:"-60px"});
            }
        });

        // Click event to scroll to top
        scrollToTop.on("click", function(){
            $('html, body').animate({scrollTop : 0},800);
            return false;
        });
    });
        
    // Cookie banner
    $( '.cookie-banner' ).on( 'click', '.cookie-agree', function (e) {
        $( e.delegateTarget ).animate( { height: 'hide', opacity: 'hide' } );

        var date = new Date();
        date.setTime( date.getTime() + ( 365 * 864e5 ) ); // cookie for 1 year
        document.cookie = "cookie-banner=1; expires=" + date.toUTCString() + "; path=/";

        return false;
    } );

    $.ifExists(['body', '.collapse'], function ($body, $collapsible) {

        $body.on('click', function (e) {
            $collapsible.collapse('hide');
        });

        $collapsible.on('click', function (e) {
            e.stopImmediatePropagation();
        });

    });

    $.ifExists("#slick-slider", function(slider){
        slider.slick({
            swipeToSlide: true,
            infinite: true,
            dots:false,
            autoplay: true,
            autoplaySpeed: 4000,
            centerMode: true,
            fade: true,
            speed: 500,
            rows: 0,
            slidesToShow: 1,
            arrows:true,
            nextArrow: '<i class="icon arrow-right prev" aria-hidden="true"></i>',
            prevArrow: '<i class="icon arrow-left next" aria-hidden="true"></i>'
        });
    });

    $('.tax-filter').click( function(event) {
        if (event.preventDefault) {
            event.preventDefault();
        } else {
            event.returnValue = false;
        }

        $('.tagged-posts').fadeOut();
        $('.pagination').fadeOut();
        var selected_taxonomy = $(this).data('title');
        
        var data = {
            action: 'filter_posts',
            afp_nonce: afp_vars.afp_nonce,
            taxonomy: selected_taxonomy,
        };

        $.ajax({
            type: 'post',
            url: afp_vars.afp_ajax_url,
            data: data,
            success: function( data, textStatus, XMLHttpRequest ) {
                $('#filter').html( data );
                $('#filter').fadeIn();
            },
            error: function( MLHttpRequest, textStatus, errorThrown ) {
                $('#filter').html( 'No posts found' );
                $('#filter').fadeIn();
            }
        });
    });

});
